export default API => {
    const getToolTags = async () => {
        try {
            const {
                data: { tags },
            } = await API.get(`/tools/tags`)
            return tags
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const createToolTag = async newTag => {
        try {
            const {
                data: { tag },
            } = await API.post(`/tools/create-tag`, { tag: newTag })
            return tag
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const updateToolTag = async ({ id, newTag }) => {
        try {
            const {
                data: { tag },
            } = await API.put(`/tools/update-tag?id=${id}`, { tag: newTag })
            return tag
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const deleteToolTag = async ({ id }) => {
        try {
            const {
                data: { tag },
            } = await API.delete(`/tools/delete-tag?id=${id}`)
            return tag
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    return {
        getToolTags,
        createToolTag,
        updateToolTag,
        deleteToolTag,
    }
}
